export default [
  {
    path: '/app/safes',
    name: 'Safes',
    component: () => import('@/views/Admin/Safes/Index.vue'),
    meta: {
      pageTitle: 'Kasalar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_SAFES',
      action: 'read',
    },
  },
  {
    path: '/app/safes/add',
    name: 'SafeAdd',
    component: () => import('@/views/Admin/Safes/Add.vue'),
    meta: {
      pageTitle: 'Kasalar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/safes',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_SAFES',
      action: 'read',
    },
  },
  {
    path: '/app/safes/edit/:id',
    name: 'SafeEdit',
    component: () => import('@/views/Admin/Safes/Edit.vue'),
    meta: {
      pageTitle: 'Kasalar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/safes',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_SAFES',
      action: 'read',
    },
  },
]
